import { render, staticRenderFns } from "./RetentionStatusBadge.vue?vue&type=template&id=f0f93314&scoped=true&"
import script from "./RetentionStatusBadge.vue?vue&type=script&setup=true&lang=ts&"
export * from "./RetentionStatusBadge.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./RetentionStatusBadge.vue?vue&type=style&index=0&id=f0f93314&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f93314",
  null
  
)

export default component.exports